import { render, staticRenderFns } from "./AddictiveStuffInfo.vue?vue&type=template&id=7f0fec66&scoped=true&"
import script from "./AddictiveStuffInfo.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0fec66",
  null
  
)

export default component.exports